// Authorize.js
import React from 'react';
import { Navigate, useLocation, useParams } from 'react-router-dom';
import PropTypes from 'prop-types';
import { IndexPage } from '../../routes/IndexPage';
import {
    NOT_AUTHORIZED_APPLICATION_MESSAGE,
    NOT_AUTHORIZED_SCREEN_MESSAGE,
    NOT_FOUND_MESSAGE,
} from '../../common/strings';
import { PARK_PORTFOLIO_KEY, PATHNAME_INDEX } from 'common/constants';
import { map } from 'lodash';
import { Loading } from 'components/Loading/Loading';
import { useRematchSelector } from 'models/rematchStore';

const SERVER_ERROR = 'Powerboard is unable to connect. Please try again later';

export const AuthorizedRoute = ({ component: Component, ...props }) => {
    const location = useLocation();
    const { park } = useParams(); // Use useParams to get the park param

    const { selectedPark, selectedScreen, parkData, isConfigLoading, configLoadingError } = useRematchSelector(
        (state) => state.appData
    );
    const { allowedRoutes, allowedScreens } = useRematchSelector((state) => state.account);
        if (configLoadingError) {
        return <IndexPage title={SERVER_ERROR} />;
    }

    if (isConfigLoading) {
        return <Loading />;
    }

    if (!allowedRoutes.length) {
        return <IndexPage title={NOT_AUTHORIZED_APPLICATION_MESSAGE} />;
    }

    if (location.pathname === PATHNAME_INDEX) {
        if (selectedPark) {
            const selectedParkScreens = allowedScreens[selectedPark.toLowerCase()];
            const defaultScreen = selectedParkScreens.includes('operations') ? 'operations' : selectedParkScreens[0];
            const newPath = `/${selectedPark}/${selectedScreen || defaultScreen}`;
            return <Navigate to={newPath.toLowerCase()} />;
        }
        return <Navigate to={allowedRoutes[0].url} />;
    }
    const parkNames = [...map(parkData, 'datasetName'), PARK_PORTFOLIO_KEY.toLowerCase()];
    if (!parkNames.includes(park)) {
        return <IndexPage title={NOT_FOUND_MESSAGE} />;
    }

    const isAuthorized = allowedRoutes.find(({ url }) => location.pathname.includes(url));

    return isAuthorized ? <Component {...props} /> : <IndexPage title={NOT_AUTHORIZED_SCREEN_MESSAGE} />;
};

AuthorizedRoute.propTypes = {
    component: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
};
